export const NORM_GEN_DATA = [
    {
        ficha: 'F-01',
        sectors: [
            {
                sector: 1,
                trata: 'TCoA-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                    { subsector: 'I' },
                ]
            },
            {
                sector: 3,
                trata: 'TC-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TRA-3',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                ]
            },
            {
                sector: 5,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 6,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-02',
        sectors: [
            {
                sector: 1,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                ]
            },
            {
                sector: 3,
                trata: 'Tco-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-03',
        sectors: [
            {
                sector: 1,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                    { subsector: 'I' },
                    { subsector: 'J' },
                ]
            },
            {
                sector: 2,
                trata: 'TRA-3',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 3,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                ]
            },
            {
                sector: 4,
                trata: 'Tco',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 5,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-04',
        sectors: [
            {
                sector: 1,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                ]
            },
            {
                sector: 3,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-05',
        sectors: [
            {
                sector: 1,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                    { subsector: 'I' },
                    { subsector: 'J' },
                ]
            },
            {
                sector: 2,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                ]
            },
            {
                sector: 3,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TM-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 5,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-06A',
        sectors: [
            {
                sector: 1,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 3,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 5,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
        ]
    },
    {
        ficha: 'F-06B',
        sectors: [
            {
                sector: 1,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 3,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 5,
                trata: false,
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
        ]
    },
    {
        ficha: 'F-07A',
        sectors: [
            {
                sector: 1,
                trata: false,
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                    { subsector: 'I' },
                ]
            },
            {
                sector: 2,
                trata: false,
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                ]
            },
        ]
    },
    {
        ficha: 'F-07B',
        sectors: [
            {
                sector: 1,
                trata: false,
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                    { subsector: 'I' },
                ]
            },
            {
                sector: 2,
                trata: false,
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                ]
            },
        ]
    },
    {
        ficha: 'F-08',
        sectors: [
            {
                sector: 1,
                trata: 'TRA-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 2,
                trata: 'TRD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 3,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                ]
            },
            {
                sector: 4,
                trata: 'Tcou-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 5,
                trata: 'TcoA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                ]
            },
            {
                sector: 6,
                trata: 'TRA-3',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                ]
            },
        ]
    },
    {
        ficha: 'F-09',
        sectors: [
            {
                sector: 1,
                trata: 'TRA-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 2,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 3,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                    { subsector: 'G' },
                    { subsector: 'H' },
                ]
            },
            {
                sector: 5,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                ]
            },
            {
                sector: 6,
                trata: 'TcoA-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-10',
        sectors: [
            {
                sector: 1,
                trata: 'TRD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 2,
                trata: 'TRA-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 3,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 4,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 5,
                trata: 'TRA-3',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                ]
            },
            {
                sector: 6,
                trata: 'TC-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 7,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 8,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-11',
        sectors: [
            {
                sector: 1,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 2,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 3,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 4,
                trata: 'TRA-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 5,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 6,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-12',
        sectors: [
            {
                sector: 1,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                    { subsector: 'E' },
                    { subsector: 'F' },
                ]
            },
            {
                sector: 2,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 3,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TRA-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 5,
                trata: 'TRA-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 6,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                ]
            },
            {
                sector: 7,
                trata: 'TcoA-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-13',
        sectors: [
            {
                sector: 1,
                trata: 'TMI-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 2,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                    { subsector: 'D' },
                ]
            },
            {
                sector: 3,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
            {
                sector: 4,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-14A',
        sectors: [
            {
                sector: 1,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 3,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
    {
        ficha: 'F-14B',
        sectors: [
            {
                sector: 1,
                trata: 'TD',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 2,
                trata: 'TC-1',
                subsectors: [
                    { subsector: 'A' },
                    { subsector: 'B' },
                    { subsector: 'C' },
                ]
            },
            {
                sector: 3,
                trata: 'TMI-2',
                subsectors: [
                    { subsector: 'A' },
                ]
            },
        ]
    },
]

export const ELEMENTS = [
    { value: "fc", name: "FC" },
    { value: "fa", name: "FA" },
    { value: "peatonal", name: "Peatonal" },
    { value: "bike", name: "Cicloruta" },
    { value: "bay", name: "Bahia" },
    { value: "parking", name: "Bolsa de Parqueadero" },
    { value: "parallel", name: "Paralela" },
    { value: "s_lat", name: "S. Lateral" },
    { value: "road", name: "Calzada" },
    { value: "s_central", name: "S. Central" },
];